import moment from 'moment-timezone';

export const highChartClockConfig = (data: { tz: string }) => {
  let config: any = {
    chart: {
      type: 'gauge',
      plotBackgroundColor: null,
      plotBackgroundImage: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: '80%',
      // events: {
      //   load: function () {
      //     const chart: any = this;
      //     let now;
      //     setInterval(() => {
      //       now = getNow(data.tz);
      //       if (chart.series && chart.series.length) {
      //         const hour = chart.get('hour');
      //         const minute = chart.get('minute');
      //         const second = chart.get('second');
      //         hour?.update(now.hours, true, false);
      //         minute?.update(now.minutes, true, false);
      //         // Move to 59 sec without animation ...
      //         if (now.seconds === 0) {
      //           second?.update(-0.2, true, false);
      //         }
      //         second?.update(now.seconds, true, false);
      //       }
      //     }, 1000);
      //   },
      // },


      events: {
        load: function () {
          const chart: any = this;

          // create digital clock text
         const digitalClock = chart.renderer
  .text(
    getNow(data.tz).currentTime,
    chart.chartWidth / 2,      // center horizontally
    chart.chartHeight - 2     // margin below chart
  )
  .css({
    fontSize: '14px',
    color: '#333',
    textAlign: 'center',
  })
  .attr({
    align: 'center',
  })
  .add();

          setInterval(() => {
            const now = getNow(data.tz);

            if (chart.series && chart.series.length) {
              const hour = chart.get('hour');
              const minute = chart.get('minute');
              const second = chart.get('second');

              hour?.update(now.hours, true, false);
              minute?.update(now.minutes, true, false);

              if (now.seconds === 0) {
                second?.update(-0.2, true, false);
              }

              second?.update(now.seconds, true, false);

              // update digital time
              digitalClock.attr({
                text: now.currentTime,
              });
            }
          }, 1000);
        },
      },
    },

    credits: {
      enabled: false,
    },

    title: {
      text: '',
    },

    yAxis: {
      labels: {
        distance: -23,
        enabled: false,
        style: {
          fontSize: '18px',
        },
      },
      min: 0,
      max: 12,
      lineWidth: 0,
      showFirstLabel: false,

      minorTickInterval: 1,
      minorTickWidth: 2,
      minorTickLength: 5,
      minorTickPosition: 'inside',
      minorGridLineWidth: 0,
      minorTickColor: '#666',

      tickInterval: 3,
      tickWidth: 3,
      tickPosition: 'inside',
      tickLength: 10,
      tickColor: '#666',
      title: {
        text: undefined,
        style: {
          color: '#BBB',
          fontWeight: 'bold',
          fontSize: '12px',
          lineHeight: '10px',
        },
        y: 10,
      },
    },
    plotOptions: {
      gauge: {
        pivot: {
          radius: 3,
        },
      },
    },
    tooltip: {
      formatter: function (): any {
        return `<span>24 Hour Clock:<br/>${getNow(data.tz).currentTime}</span>`;
      },
    },

    series: [
      {
        data: [
          {
            id: 'hour',
            y: getNow(data.tz).hours,
            dial: {
              radius: '60%',
              baseWidth: 2,
              baseLength: '95%',
              rearLength: 0,
            },
          },
          {
            id: 'minute',
            y: getNow(data.tz).minutes,
            dial: {
              baseWidth: 2,
              baseLength: '95%',
              rearLength: 0,
            },
          },
          {
            id: 'second',
            y: getNow(data.tz).seconds,
            dial: {
              radius: '100%',
              baseWidth: 1,
              rearLength: '20%',
            },
          },
        ],
        animation: false,
        dataLabels: {
          enabled: false,
        },
      },
    ],
  };

  return config;
};

const getNow: any = (timeZone: string) => {
  let now: moment.Moment = moment();
  if (timeZone === 'EST') {
    now = moment().tz('US/Eastern');
  } else if (timeZone === 'CT') {
    now = moment().tz('US/Central');
  } else if (timeZone === 'MT') {
    now = moment().tz('US/Mountain');
  } else if (timeZone === 'PT') {
    now = moment().tz('US/Pacific');
  }
  return {
    currentTime: now.format('HH:mm:ss'),
    hours: now.hours() + now.minutes() / 60,
    minutes: (now.minutes() * 12) / 60 + (now.seconds() * 12) / 3600,
    seconds: (now.seconds() * 12) / 60,
  };
};
